<script setup lang="ts">
import { useFieldErrors, type FieldErrors } from '@/shared/lib';

const { errors } = defineProps<{ errors: FieldErrors }>();

const { errorsToShow, isHasErrors } = useFieldErrors(() => errors);
</script>

<template>
  <div v-if="isHasErrors">
    <div
      v-for="(idx, error) in errorsToShow"
      :key="idx"
    >
      {{ error }}
    </div>
  </div>
</template>
